import DraggerBox from './DraggerBox'
import ImageUploader from './ImageDraggerBox'

export default Object.assign(DraggerBox, {
  ImageUploader,
})
